import { Component, ElementRef, Inject } from '@angular/core';

import { EventBus, EventBusBase, RoutingService } from '@skylab-angular-shared/core';

import { MenuComponentBase } from '../menu-base.component';
import { MenuItemOptionComponent } from '../menu-item-option/menu-item-option.component';
import { MenuItemOption } from '../menu.model';

@Component({
    selector: 'skl-menu-options',
    templateUrl: './menu-options.component.html',
    imports: [MenuItemOptionComponent]
})
export class MenuOptionsComponent extends MenuComponentBase {
    public constructor(
        elRef: ElementRef,
        routingService: RoutingService,
        @Inject(EventBus) eventBus: EventBusBase) {
        super(elRef, eventBus, routingService);
    }

    public override onItemSelect(item: MenuItemOption): void {
        if (item.isDisabled(this.context)) return;
        item.isChecked = !item.isChecked;
        item.click?.(item);
        if (item.disableIcon) this.close();
    }
}
